"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MatchFactorWrapper = exports.MatchFactorCircle = exports.MatchFactor = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _baseReactComponents = require("@navinc/base-react-components");

var _useMatchFactorDescriptionDrawer = require("../match-factor-description/use-match-factor-description-drawer");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["score", "noMatchFactorLink", "isPrequalified", "showInfoIcon", "shouldShowMatchFactorDescriptionDrawer", "onClick"];
var azure = _baseReactComponents.theme.azure,
    bubbleBlue100 = _baseReactComponents.theme.bubbleBlue100,
    bubbleBlue400 = _baseReactComponents.theme.bubbleBlue400,
    flounderYellow100 = _baseReactComponents.theme.flounderYellow100,
    flounderYellow200 = _baseReactComponents.theme.flounderYellow200,
    seaturtleGreen100 = _baseReactComponents.theme.seaturtleGreen100,
    seaturtleGreen200 = _baseReactComponents.theme.seaturtleGreen200,
    sebastianRed100 = _baseReactComponents.theme.sebastianRed100,
    sebastianRed200 = _baseReactComponents.theme.sebastianRed200,
    scuttleGray300 = _baseReactComponents.theme.scuttleGray300,
    scuttleGray500 = _baseReactComponents.theme.scuttleGray500;
var Checkmark = (0, _styledComponents["default"])(_baseReactComponents.Icon).withConfig({
  displayName: "Checkmark",
  componentId: "sc-1jt4cuj-0"
})([""]);

var MatchFactorContainer = _styledComponents["default"].div.withConfig({
  displayName: "MatchFactorContainer",
  componentId: "sc-1jt4cuj-1"
})(["display:flex;align-items:flex-start;cursor:pointer;", "{margin-left:0.3em;width:1.4em;height:1.4em;fill:", ";}"], _baseReactComponents.Icon, function (_ref) {
  var theme = _ref.theme;
  return theme.neutral400;
});

var MatchFactorDiv = _styledComponents["default"].div.withConfig({
  displayName: "MatchFactorDiv",
  componentId: "sc-1jt4cuj-2"
})(["display:flex;align-items:center;justify-content:center;height:40px;padding:8px 16px;border-radius:20px;background-color:", ";& > ", "{margin-right:4px;}"], function (_ref2) {
  var color = _ref2.color;
  return color;
}, Checkmark);

var MatchFactorCircle = _styledComponents["default"].div.withConfig({
  displayName: "MatchFactorCircle",
  componentId: "sc-1jt4cuj-3"
})(["border-radius:50%;width:10px;height:10px;margin-right:5px;background-color:", ";"], function (_ref3) {
  var color = _ref3.color;
  return color;
});

exports.MatchFactorCircle = MatchFactorCircle;

var MatchFactorWrapper = _styledComponents["default"].div.withConfig({
  displayName: "MatchFactorWrapper",
  componentId: "sc-1jt4cuj-4"
})(["& > ", "{width:max-content;margin-bottom:16px;}"], MatchFactorContainer);

exports.MatchFactorWrapper = MatchFactorWrapper;

var getMatchFactorDetails = function getMatchFactorDetails(score, isPrequalified) {
  if (isPrequalified) return {
    color: bubbleBlue400
  };
  if (typeof score !== 'number') return {
    color: scuttleGray300,
    circle: scuttleGray500
  };

  if (score >= 90) {
    return {
      color: seaturtleGreen100,
      circle: seaturtleGreen200
    };
  } else if (score >= 79) {
    return {
      color: bubbleBlue100,
      circle: bubbleBlue400
    };
  } else if (score >= 61) {
    return {
      color: flounderYellow100,
      circle: flounderYellow200
    };
  } else if (score < 61) {
    return {
      color: sebastianRed100,
      circle: sebastianRed200
    };
  } else {
    return {
      color: scuttleGray300,
      circle: scuttleGray500
    };
  }
};

var MatchFactor = function MatchFactor(_ref4) {
  var _onClick;

  var score = _ref4.score,
      _ref4$noMatchFactorLi = _ref4.noMatchFactorLink,
      noMatchFactorLink = _ref4$noMatchFactorLi === void 0 ? 'https://app.nav.com/registration' : _ref4$noMatchFactorLi,
      _ref4$isPrequalified = _ref4.isPrequalified,
      isPrequalified = _ref4$isPrequalified === void 0 ? false : _ref4$isPrequalified,
      _ref4$showInfoIcon = _ref4.showInfoIcon,
      showInfoIcon = _ref4$showInfoIcon === void 0 ? false : _ref4$showInfoIcon,
      _ref4$shouldShowMatch = _ref4.shouldShowMatchFactorDescriptionDrawer,
      shouldShowMatchFactorDescriptionDrawer = _ref4$shouldShowMatch === void 0 ? false : _ref4$shouldShowMatch,
      onClick = _ref4.onClick,
      rest = (0, _objectWithoutProperties2["default"])(_ref4, _excluded);

  var _getMatchFactorDetail = getMatchFactorDetails(score, isPrequalified),
      color = _getMatchFactorDetail.color,
      circle = _getMatchFactorDetail.circle;

  var showMatchFactorDescriptionDrawer = (0, _useMatchFactorDescriptionDrawer.useMatchFactorDescriptionDrawer)();
  onClick = (_onClick = onClick) !== null && _onClick !== void 0 ? _onClick : shouldShowMatchFactorDescriptionDrawer ? showMatchFactorDescriptionDrawer : null;

  var renderMatchFactorText = function renderMatchFactorText() {
    if (typeof score === 'number') {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_baseReactComponents.Copy, {
        size: "sm",
        children: [score, "% MatchFactor"]
      });
    } else {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Link, {
        href: noMatchFactorLink,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
          size: "sm",
          children: "Get matched now"
        })
      });
    }
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(MatchFactorContainer, Object.assign({
    onClick: onClick
  }, rest, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(MatchFactorDiv, {
      color: color,
      "data-testid": "matchfactor",
      children: [isPrequalified ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Checkmark, {
          name: "actions/done",
          color: azure
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
          size: "sm",
          children: "Pre-qualified offer"
        })]
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(MatchFactorCircle, {
        color: circle
      }), !isPrequalified && renderMatchFactorText()]
    }), showInfoIcon && shouldShowMatchFactorDescriptionDrawer && /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Icon, {
      name: "actions/circle-faq"
    })]
  }));
};

exports.MatchFactor = MatchFactor;
MatchFactor.propTypes = {
  score: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  noMatchFactorLink: _propTypes["default"].string,
  isPrequalified: _propTypes["default"].bool
};
var _default = MatchFactor;
exports["default"] = _default;
//# sourceMappingURL=index.js.map